// extracted by mini-css-extract-plugin
export default {"shadowed":"BaseLayout_shadowed__dUF53","dark":"BaseLayout_dark__zdyKW","light":"BaseLayout_light__6Fnqc"};